import type { Option } from '@branchjs/neo-components';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_CAMPAIGN = 'UPDATE_QR_CODE_LINK_CAMPAIGN' as const;

export const updateQrCodeLinkCampaign = (campaign: Option) => ({
  data: { campaign },
  type: UPDATE_QR_CODE_LINK_CAMPAIGN,
});

export type UpdateQrCodeLinkCampaignResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_CAMPAIGN, { campaign: Option }>;
